import { TDescriptionValue } from 'shared/types/typographyComponents';

export const FIRST_DESCR: TDescriptionValue[] = [
  { value: 'Качество базы объявлений — стратегический актив Циан.', isBold: true },
  {
    value:
      ' Чем меньше фейковых и устаревших объектов, тем выше доверие пользователей и конверсия в сделки. Это обеспечивает рост аудитории и устойчивость бизнеса. Комбинация ИИ-модерации и ручных проверок поддерживает чистоту базы и сохраняет конкурентное преимущество.',
  },
];

export const SECOND_DESCR: TDescriptionValue[] = [
  { value: 'Результат:', isBold: true },
  {
    value: ' 99% объектов имеют подтверждённый индекс достоверности, доля фейков сократилась с 5% до 1% за пять лет',
  },
];

export const LIST: TDescriptionValue[][] = [
  [{ value: 'Нейросети обучаются на реальных данных, выявляют сомнительные объекты и новые схемы фрода' }],
  [{ value: 'Большие языковые модели снижают нагрузку на сотрудников и повышают точность модерации' }],
  [
    {
      value:
        'ИИ оценивает качество коммуникации риелторов в программе лояльности «Суперагент» (скорость ответа, полнота информации, вежливость), исключая спам и ботов',
    },
  ],
];

export const UTP = [
  {
    title: 'Автоматическая модерация',
    descr:
      'ИИ анализирует десятки параметров (цена, характеристики, поведение) и блокирует подозрительные объявления до публикации',
    image: 'stars',
  },
  {
    title: 'Ручная проверка',
    descr: 'Модераторы рассматривают сложные случаи и оспаривания, принимают окончательные решения',
    image: 'headphones',
  },
];
